<template>
  <v-navigation-drawer app style="top: auto" :clipped="$vuetify.breakpoint.lgAndUp">
    <v-container>
      <v-list-item two-line @click="toPage('User', '/user')">
        <v-list-item-avatar>
          <v-img :src="loginUserPhotoURL" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title> {{ loginUserName }} </v-list-item-title>
          <v-list-item-subtitle> {{ loginUserEmail }} </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list nav dense>
        <v-list-item color="primary" link :key="index" v-for="(item, index) in items" @click="toPage(item.name, item.path)">
          <v-list-item-icon>
            <v-icon color="primary"> {{ item.icon }} </v-icon>
          </v-list-item-icon>
          <v-list-item-title> {{ item.title }} </v-list-item-title>
        </v-list-item>
      </v-list>

      <v-list nav dense>
        <v-list-item color="primary" @click="logout()">
          <v-list-item-icon>
            <v-icon color="primary"> mdi-logout </v-icon>
          </v-list-item-icon>
          <v-list-item-title> Logout </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import firebase from "firebase";
import { mapGetters, mapMutations } from "vuex";

export default {
  data: () => ({
    items: [
      { icon: "mdi-home", name: "Top", path: "/top", title: "Top" },
      { icon: "mdi-run", name: "JobIndex", path: "/job_index", title: "My Jobs" },
      { icon: "mdi-account-heart", name: "Friend", path: "/friend", title: "My Friends" },
      { icon: "mdi-account-group", name: "GroupIndex", path: "/group_index", title: "My Groups" },
      { icon: "mdi-frequently-asked-questions", name: "FAQ", path: "/faq", title: "FAQ" }
    ]
  }),

  computed: {
    ...mapGetters(["loginStatus", "loginUserEmail", "loginUserId", "loginUserName", "loginUserPhotoURL"])
  },

  methods: {
    ...mapMutations(["job/resetMyJobs", "record/resetTimeLine"]),
    // ログアウトします.
    logout() {
      if (confirm("ログアウトしてもよろしいですか？")) {
        firebase
          .auth()
          .signOut()
          .then(() => {
            this["job/resetMyJobs"]();
            this["record/resetTimeLine"]();
            alert("ログアウトに成功しました");
          })
          .catch((error) => {
            console.log(error.message);
            alert("ログアウトに失敗しました\n" + error.message);
          });
      }
    },
    // 各ページに遷移します.
    toPage(name, path) {
      console.log("this.$router.currentRoute.path: ", this.$router.currentRoute.path, "path: ", path)
      this.$router.currentRoute.path === path ? this.$emit("rerender") : this.$router.push({ name: name, params: { isLoginUser: true } });
    }
  }
};
</script>
